<template>
  <v-content v-if="loading">
    <breadcrumbs></breadcrumbs>
    <transition name="fade">
      <loading v-if="isLoading"></loading>
    </transition>
    <v-row class="rows center-style">
      <v-flex class="news-group">
        <v-flex>

          <v-row class="news"
                 v-for="(item,i) in newsList"
                 :key="i">
            <!-- <v-divider v-if="i !=0 "
                       class="divider"></v-divider> -->
            <div style="width:40%">
              <v-responsive class="news-image"
                            :aspect-ratio="16/9">
                <img @click="$router.push({name:'NewContent',query: {newsId:item.newsId,yearList:yearList}}) "
                     :src="item.photo" />
              </v-responsive>
              <v-flex class="news-date">
                {{item.createTime}}
              </v-flex>
            </div>

            <div style="width:60%;min-width: 300px;position:relative;">
              <v-flex class="news-title">
                {{item.newsTitle}}
              </v-flex>

              <v-flex class="news-content">
                {{item.newsIntroduction}}
              </v-flex>

              <v-btn class="look-more"
                     @click="$router.push({name:'NewContent',query: {newsId:item.newsId,hot:item.hot,yearList:yearList}}) ">
                查看详情>>>
              </v-btn>
            </div>
          </v-row>
        </v-flex>

        <v-pagination v-model="pagination.page"
                      :length="pagination.length"
                      :total-visible="pagination.visible"
                      @input="selectPage">
        </v-pagination>
      </v-flex>

      <!-- 右部· -->
      <v-flex class="others">
        <!-- 查询 -->
        <v-card-title>
          <v-text-field v-model="pagination.searchWord"
                        append-icon="fa fa-search"
                        label="Search"
                        single-line
                        hide-details
                        @change="doSearch">
          </v-text-field>
        </v-card-title>

        <!-- 历史档案 -->
        <v-flex class="div-title">
          <v-flex class="title-text">历史档案</v-flex>
          <v-divider class="blue-divider"></v-divider>
          <ul>
            <li v-for="(item,i) in yearList"
                :key="'1'+i">
              <!-- <font>{{item.yearName}}年 ({{item.yearCount}})</font> -->
              <v-row class="year-list">
                <font>{{item.yearName}}年</font>
                <v-spacer></v-spacer>
                <font>({{item.yearCount}})</font>
              </v-row>
            </li>
          </ul>
        </v-flex>

        <!-- 关于我们 -->
        <v-flex class="div-title">
          <v-flex class="title-text">关于我们</v-flex>
          <v-divider class="blue-divider"></v-divider>
          <v-flex>
            <img class="image"
                 @click="$router.push({ name: 'CompanyProfile' })"
                 src="@/images/text/aboutUs.jpg" />
          </v-flex>
          <v-flex class="news-content">

          </v-flex>
        </v-flex>

        <!-- 产品介绍 -->
        <v-flex class="div-title">
          <v-flex class="title-text">产品介绍</v-flex>
          <v-divider class="blue-divider"></v-divider>
          <v-flex>
            <img class="image"
                 @click="$router.push({ name: 'Product' })"
                 src="@/images/text/product.jpg" />
          </v-flex>
        </v-flex>
      </v-flex>
    </v-row>
  </v-content>
</template>
<script>

import Loading from '@/components/core/Loading' //引入新闻列表分页 api 接口

export default {
  components: { Loading },
  data () {
    return {
      loading: false,
      search: '',
      pagination: {
        //初始页码
        page: 1,
        //总条数
        total: 0,
        //指定最大可见分页数
        visible: 10,
        //每页数量
        pageNum: 5,
        //关键字
        searchWord: null,
        //页面数
        length: 0
      },
      isLoading: false,
      //新闻列表
      newsList: [],
      //年份列表
      yearList: []
    }
  },
  created () {
    this.init()
  },
  mounted () {
    this.$emit("updateToolbarValue", 2)
  },
  methods: {
    //初期化
    init () {
      this.isLoading = true;
      this.$store
        .dispatch("GetNewsList", this.pagination)
        .then(response => {
          this.newsList = response.data.data;
          //总条数
          this.pagination.total = response.data.data2;
          this.pagination.length = parseInt(this.pagination.total / this.pagination.pageNum) + 1;
          this.yearList = response.data.data3;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
      this.loading = true;
    },

    /**
     * 页码选择
     */
    selectPage () {
      this.isLoading = true;
      this.$store
        .dispatch("GetNewsListByPage", this.pagination)
        .then(response => {
          this.newsList = response.data.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    /**
     * 关键字查询
     */
    doSearch () {
      this.isLoading = true;
      this.$store
        .dispatch("GetNewsList", this.pagination)
        .then(response => {
          this.newsList = response.data.data;
          //总条数
          this.pagination.total = response.data.data2;
          this.pagination.length = parseInt(this.pagination.total / this.pagination.pageNum) + 1;
          this.yearList = response.data.data3;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

  }
}
</script>

<style scoped>
.rows {
  margin: 70px 0 0 0;
}
.center-style {
  display: flex;
  justify-content: center;
  align-content: center;
}
.news-group {
  width: 75%;
  max-width: 900px;
  flex: none;
}
.news-list {
  margin-bottom: 40px;
}
.news {
  margin-right: 10px;
}
.news-image {
  width: 100%;
  min-width: 300px;
  height: 250px;
  flex: none;
  cursor: pointer;
}
.image {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.news-date {
  height: 30px;
  width: 100px;
  background: black;
  color: azure;
  display: flex;
  justify-content: center;
  align-items: center;
}
.news-title {
  margin: 10px;
  font-size: 20px;
}
.news-content {
  margin: 10px;
  font-size: 14px;
  color: gray;
}

.year-list {
  margin: 0;
  padding: 0 20px 0 20px;
}

.others {
  max-width: 400px;
  flex: none;
}
.blue-divider {
  width: 30px;
  border: 2px solid #42a5f6 !important;
  margin: 3px 0 20px 0;
}
.div-title {
  margin-top: 20px;
  padding: 20px;
}
.title-text {
  font-size: 20px;
}
.look-more {
  font-size: 14px;
  background: #42a5f6 !important;
  color: #fff;
  position: absolute;
  right: 0;
  bottom: 0px;
}
</style>